<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div
      class="fixed inset-0 bg-black bg-opacity-50"
      @click="onCancel"
    ></div>

    <!-- Modal -->
    <div class="relative w-full max-w-md mx-4 bg-white rounded-lg shadow-lg">
      <!-- Close button -->
      <button
        @click="onCancel"
        class="absolute text-gray-400 top-4 right-4 hover:text-gray-600 focus:outline-none"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>

      <!-- Modal content -->
      <div class="p-6 text-center">
        <!-- Title -->
        <h3 class="mb-4 text-lg font-semibold text-gray-900">
          {{ title }}
        </h3>

        <!-- Message -->
        <p v-if="hasAdminWarning" class="mb-6 leading-relaxed text-gray-600">
          You've assigned {{ adminCountLabel }} to <b>{{ vendorName }}</b> before. Please recheck before continuing.
        </p>
        <p v-else class="mb-6 leading-relaxed text-gray-600">
          {{ message || '' }}
        </p>

        <!-- Action buttons -->
        <div class="flex justify-center space-x-3">
          <Button
            @click="onContinue"
            color="primary"
            size="base"
            class="px-6 py-2"
          >
            {{ continueText }}
          </Button>

          <Button
            @click="onCancel"
            color="alternative"
            variant="outlined"
            size="base"
            class="px-6 py-2"
          >
            {{ cancelText }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/Button';

export default {
  name: 'ConfirmationModal',
  components: {
    Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Do you want to continue?'
    },
    message: {
      type: String,
      required: false
    },
    continueText: {
      type: String,
      default: 'Continue'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    adminCount: {
      type: Number,
      default: 0
    },
    vendorName: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasAdminWarning() {
      return Boolean(this.adminCount && this.vendorName);
    },
    adminCountLabel() {
      return `${this.adminCount} admin${this.adminCount > 1 ? 's' : ''}`;
    }
  },
  methods: {
    onContinue() {
      this.$emit('continue');
      this.$emit('update:visible', false);
    },
    onCancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
/* Custom styling to match the screenshot design */
.modal-backdrop {
  backdrop-filter: blur(2px);
}
</style>
